import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  calculateRating(order: number): number {
    if (order <= 3) return 9.9;
    if (order <= 7) return 9.7;
    if (order <= 12) return 9.5;
    if (order <= 18) return 9.3;
    return 9.1;
  }

  calculateStars(order: number): number {
    if (order <= 3) return 5;
    if (order <= 7) return 4.5;
    return 4;
  }
}

